import { ReactNode, useEffect, useMemo, useState } from 'react';

// material-ui
import { AppBar, AppBarProps, Fade, Toolbar, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LogoSection from 'components/logo';
import { useSelector } from 'store';
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const Header = () => {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));
  const menu = useSelector((state) => state.menu);
  const { drawerOpen } = menu;

  const headerContent = useMemo(() => <HeaderContent />, []);

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const listenToScroll = () => {
      let heightToHideFrom = 100;
      const winScroll = document.body.scrollTop || document.documentElement.scrollTop;

      if (winScroll > heightToHideFrom) {
        setVisible(true);
      } else {
        visible && setVisible(false);
      }
    };

    window.addEventListener('scroll', listenToScroll);
    return () => window.removeEventListener('scroll', listenToScroll);
  }, [visible]);

  // common header
  const mainHeader: ReactNode = (
    <Toolbar>
      <LogoSection
        isIcon
        sx={{ width: 'auto', height: 80, opacity: 0.6 }}
        colorOverride={'#ffffff'}
      />
      {headerContent}
    </Toolbar>
  );

  // app-bar params
  const appBar: AppBarProps = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      zIndex: 1200,
      width: '100%',
      backgroundColor: 'transparent'
    }
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={drawerOpen} {...appBar}>
          <Fade in={!visible}>{mainHeader}</Fade>
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>
          <Fade in={!visible}>{mainHeader}</Fade>
        </AppBar>
      )}
    </>
  );
};

export default Header;
